var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDpd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9863 16.1836L67.2849 17.6474L68.0187 17.2401L65.9863 16.1836Z",
    fill: "#DC0032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0352 15.1289L66.5555 18.0564L67.4506 17.5685L66.4748 16.4313L64.0352 15.1289Z",
    fill: "#DC0032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.999 14.0703L65.8217 18.4616L66.7169 17.9737L64.5232 15.3689L61.999 14.0703Z",
    fill: "#DC0032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0469 13.0156L65.0913 18.8669L65.9865 18.3789L62.4903 14.3103L60.0469 13.0156ZM69.7285 23.3427L69.156 23.6654L69.7247 24.3185L69.7285 23.3427Z",
    fill: "#DC0032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0996 11.9531L64.3619 19.272L65.2533 18.784L60.5354 13.2555L58.0996 11.9531ZM69.4025 23.5019L68.5074 24.0705L69.7252 25.5343V23.9898L69.4025 23.5019Z",
    fill: "#DC0032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 10.8984L63.6272 19.6811L64.6031 19.1931L58.5828 12.2008L56.0625 10.8984ZM68.6678 23.911L67.7727 24.4796L69.7243 26.7579V25.2134L68.6678 23.911Z",
    fill: "#DC0032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1113 9.83984L62.9746 20.0862L63.8698 19.5983L56.5509 11.1423L54.1113 9.83984ZM67.9384 24.3969L67.0432 24.8848L69.7249 28.0544V26.5099L67.9384 24.3969Z",
    fill: "#DC0032"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1592 8.78516L62.2442 20.4953L63.1394 20.0074L54.5988 10.0876L52.1592 8.78516ZM67.2041 24.8059L66.3089 25.2939L69.7282 29.2779V27.7335L67.2041 24.8059Z",
    fill: "#DC0032"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.127 7.72266L61.5105 20.9004L62.4057 20.4125L52.6472 9.02506L50.127 7.72266ZM66.4743 25.211L65.5791 25.699L69.7284 30.4937V28.9492L66.4743 25.211Z",
    fill: "#DC0032"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1758 6.67188L60.7773 21.3864L61.6763 20.8216L50.6154 7.97044L48.1758 6.67188ZM65.741 25.6163L64.8458 26.1043L69.7251 31.798V30.2535L65.741 25.6163Z",
    fill: "#DC0032"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1436 5.60938L60.0513 21.7954L60.9426 21.2229L48.6639 6.91563L46.1436 5.60938ZM65.0919 26.0215L64.116 26.5094L69.7252 33.0176V31.4654L65.0919 26.0215Z",
    fill: "#DC0032"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1914 4.55469L59.317 22.2006L60.2929 21.632L46.7117 5.8571L44.1914 4.55469ZM64.3614 26.4305L63.4624 26.9185L69.7248 34.318V32.6967L64.3614 26.4305Z",
    fill: "#DC0032"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2393 3.49609L58.6673 22.6058L59.5586 22.0372L44.6789 4.7985L42.2393 3.49609ZM63.6272 26.8357L62.732 27.3236L69.7243 35.5376V33.9932L63.6272 26.8357Z",
    fill: "#DC0032"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.207 2.35938L57.9336 23.0135L58.8288 22.4449L42.7273 3.74246L40.207 2.35938ZM62.8935 27.2434L61.9984 27.7314L69.7245 36.7599V35.2116L62.8935 27.2434Z",
    fill: "#DC0032"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2559 1.30469L57.2042 23.4226L58.0955 22.9347L40.7762 2.68778L38.2559 1.30469ZM62.1641 27.6525L61.2689 28.1405L69.725 38.0603V36.4351L62.1641 27.6525Z",
    fill: "#DC0032"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3037 0.328125L56.4738 23.8291L57.3651 23.3412L38.7433 1.62669L36.3037 0.328125ZM61.4298 28.0552L60.5347 28.5431L69.7245 39.2774V37.733L61.4298 28.0552Z",
    fill: "#DC0032"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.002 0.00186867L55.7406 24.2367L56.6319 23.7487L36.7923 0.570472L36.3044 0.328431C35.9104 0.0971384 35.4584 -0.0162051 35.002 0.00186867ZM60.7005 28.4628L59.8053 28.9507L69.7252 40.4995V38.955L60.7005 28.4628Z",
    fill: "#DC0032"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0012 0C34.6747 0 34.3481 0.0806802 34.0254 0.16136L55.0061 24.6382L55.9819 24.1503L35.2471 0L35.0012 0ZM60.0505 28.8681L59.1553 29.3561L69.7244 41.8V40.171L60.0505 28.8681Z",
    fill: "#DC0032"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2717 0.0820312C34.1065 0.162711 33.8645 0.243392 33.7838 0.327914L33.2959 0.569954L54.3573 25.0468L55.2524 24.5589L34.2717 0.0858732V0.0820312ZM59.3172 29.2767L58.422 29.8453L69.7249 43.0231V41.4748L59.3172 29.2767Z",
    fill: "#DC0032"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4567 0.410156L32.5615 0.898079L53.6229 25.4556L54.5181 24.9677L33.4567 0.410156ZM58.5828 29.6855L57.6915 30.2541L69.7243 44.2387V42.6943L58.5828 29.6855Z",
    fill: "#DC0032"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7234 0.816406L31.832 1.30433L52.8934 25.8618L53.7886 25.3739L32.7234 0.816406ZM57.8495 30.0918L56.9581 30.6604L69.7248 45.5401V43.9957L57.8495 30.0918Z",
    fill: "#DC0032"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9938 1.21875L31.0986 1.70667L52.16 26.268L53.0552 25.7801L31.9938 1.21875ZM57.1199 30.4941L56.2286 31.0666L69.7252 46.7608V45.2163L57.1199 30.4941Z",
    fill: "#DC0032"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2595 1.62891L30.3682 2.11683L51.4295 26.6782L52.3247 26.1903L31.2595 1.62891ZM56.3856 30.9043L55.4943 31.4729L69.7247 47.9816V46.4371L56.3856 30.9043Z",
    fill: "#DC0032"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5299 2.03906L29.6309 2.5193L50.6922 27.0768L51.5874 26.5889L30.5299 2.03906ZM55.7405 31.3144L54.8453 31.8792L69.7251 49.2831V47.7386L55.7405 31.3144Z",
    fill: "#DC0032"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7956 2.35938L28.9043 2.92798L50.0463 27.4855L50.9415 26.9976L29.7956 2.35938ZM55.0063 31.7961L54.1111 32.284L69.7246 50.4985V48.9541L55.0063 31.7961Z",
    fill: "#DC0032"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0661 2.76953L28.1709 3.25745L49.3129 27.8956L50.2081 27.4077L29.0661 2.76953ZM54.2767 32.2063L53.3815 32.6942L69.725 51.8039V50.1787L54.2767 32.2063Z",
    fill: "#DC0032"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3318 3.17188L27.4404 3.6598L48.5825 28.3825L49.4776 27.8139L28.3318 3.17188ZM53.5424 32.6125L52.6472 33.1004L69.7245 53.0245V51.4762L53.5424 32.6125Z",
    fill: "#DC0032"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6022 3.57812L26.707 4.06605L47.8491 28.7888L48.7442 28.2202L27.6022 3.57812ZM52.8128 33.0187L51.9177 33.5066L69.7249 54.2414V52.697L52.8128 33.0187Z",
    fill: "#DC0032"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8679 3.98438L25.9766 4.4723L47.1186 29.1988L48.0138 28.6302L26.8679 3.98438ZM52.0785 33.425L51.1834 33.9129L69.7244 55.5428V53.9177L52.0785 33.425Z",
    fill: "#DC0032"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1345 4.39453L25.2432 4.88245L46.3852 29.6052L47.2804 29.0327L26.1345 4.39453ZM51.4296 33.8313L50.5345 34.3192L69.7248 56.7636V55.2192L51.4296 33.8313Z",
    fill: "#DC0032"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4046 4.71875L24.4287 5.20667L45.736 30.0062L46.6311 29.4376L25.4046 4.71875ZM50.6959 34.2362L49.8007 34.7241L69.7249 57.983V56.4386L50.6959 34.2362Z",
    fill: "#DC0032"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6741 5.125L23.6982 5.61292L45.0862 30.497C45.1499 30.3531 45.265 30.238 45.4089 30.1743L45.8968 29.8477L24.6741 5.125ZM49.9654 34.6463L49.0702 35.1342L69.563 59.0424C69.655 58.8091 69.7095 58.5628 69.7244 58.3124V57.6593L49.9654 34.6463Z",
    fill: "#DC0032"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9445 5.53516L22.9648 6.01924L44.8445 31.4719V31.1492C44.8445 30.9033 45.0097 30.5806 45.1711 30.3347L23.9445 5.53516ZM49.232 35.0526L48.5789 35.4598C48.502 35.4598 48.4214 35.5367 48.3368 35.5367L69.1562 59.856C69.3824 59.5666 69.5483 59.2348 69.6441 58.8801L49.232 35.0526Z",
    fill: "#DC0032"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2112 5.9375L22.2354 6.42542L44.8412 32.7733V31.1481L23.2112 5.9375ZM46.9542 35.1322L68.5842 60.4235C68.8301 60.2583 69.076 59.9356 69.318 59.6935L48.5025 35.4588C48.3231 35.5394 48.1287 35.5812 47.932 35.5812C47.7353 35.5812 47.5408 35.5394 47.3615 35.4588L46.9542 35.1322Z",
    fill: "#DC0032"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4768 6.34375L21.501 6.83167L67.8575 60.8298L68.5106 60.5032L68.7527 60.2573L47.4493 35.4578H47.3647L45.4976 34.3167C45.3324 34.2399 45.2517 34.0747 45.0903 33.9095C44.9251 33.6674 44.9251 33.5061 44.8444 33.3409V32.4457L22.4768 6.34375Z",
    fill: "#DC0032"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7473 6.75391L20.7715 7.24183L67.1242 61.2361L68.0193 60.7482L21.7473 6.75391Z",
    fill: "#DC0032"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.013 7.07422L20.0371 7.56214L66.4743 61.6409L67.3656 61.153L21.013 7.07422Z",
    fill: "#DC0032"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2835 7.48047L19.3076 7.96839L65.741 62.0472L66.6361 61.5592L20.2835 7.48047Z",
    fill: "#DC0032"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5491 7.89062L18.5732 8.37855L65.0143 62.4573L65.9056 61.9694L19.5491 7.89062Z",
    fill: "#DC0032"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7389 8.29688L17.8438 8.7848L64.2771 62.9442L65.1723 62.3756L18.7389 8.29688Z",
    fill: "#DC0032"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0045 8.70312L17.1094 9.19105L63.5466 63.3505L64.4379 62.7819L18.0045 8.70312Z",
    fill: "#DC0032"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.275 9.10547L16.3799 9.59723L62.8939 63.7567L63.7891 63.1842L17.275 9.10547Z",
    fill: "#DC0032"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5407 9.43359L15.6455 9.92152L62.1634 64.1616L63.0586 63.593L16.5407 9.43359Z",
    fill: "#DC0032"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8112 9.83984L14.916 10.3278L61.4301 64.5679L62.3252 64.08L15.8112 9.83984Z",
    fill: "#DC0032"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0778 10.25L14.1826 10.7379L36.7923 37.0858L37.5222 37.5737C37.8488 37.735 38.1754 38.1423 38.1754 38.5495V38.6302L60.7005 64.9781L61.5957 64.4901L15.0778 10.25Z",
    fill: "#DC0032"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3473 10.6562L13.4521 11.1442L34.6749 35.9476L37.3604 37.4075L14.3473 10.6562ZM38.0903 38.3027C38.0903 38.3872 38.1749 38.4679 38.1749 38.5485V39.9316L59.9662 65.3843L60.8614 64.8964L38.0903 38.3027Z",
    fill: "#DC0032"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6139 11.0625L12.7188 11.5504L32.5622 34.7248L35.2477 36.1886L13.6139 11.0625ZM38.1753 39.6079V41.1485L59.3173 65.7906L60.2125 65.3026L38.1753 39.6079Z",
    fill: "#DC0032"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8796 11.4648L11.9883 11.9528L30.5294 33.5059L33.1303 34.9658L12.8796 11.4648ZM38.1748 40.8247V42.4499L58.583 66.1929L59.4782 65.7088L38.1748 40.8247Z",
    fill: "#DC0032"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.15 11.7969L11.2549 12.281L28.4167 32.2858L31.0177 33.8302L12.15 11.7969ZM38.1752 42.1249V43.6694L57.8534 66.6056L58.7486 66.1138L38.1752 42.1249Z",
    fill: "#DC0032"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4196 12.1992L10.5244 12.6871L26.2993 31.0669L28.9041 32.6113L11.4196 12.1992ZM38.1747 43.3456V44.8901L57.1191 67.0079L58.0143 66.52L38.1747 43.3456Z",
    fill: "#DC0032"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.69 12.6016L9.79102 13.0933L24.1867 29.9247L26.7876 31.3885L10.69 12.6016ZM38.1751 44.5663V46.1914L56.3857 67.4948L57.2847 66.9262L38.1751 44.5663Z",
    fill: "#DC0032"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95571 13.0156L9.06055 13.5035L22.0731 28.7098L24.6741 30.1698L9.95571 13.0156ZM38.1746 45.864V47.4123L55.7398 67.905L56.6311 67.3364L38.1746 45.864Z",
    fill: "#DC0032"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22231 13.418L8.32715 13.9059L19.9566 27.4871L22.6421 28.9508L9.22231 13.418ZM38.175 47.0847V48.6329L55.0064 68.3112L55.9016 67.7426L38.175 47.0847Z",
    fill: "#DC0032"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49185 13.8242L7.59668 14.3121L17.8431 26.2682L20.5247 27.8126L8.49185 13.8242ZM29.7953 40.1721L31.9083 42.6117V41.7165C31.9083 41.5551 31.7469 41.3131 31.5856 41.2286L29.7953 40.1721ZM38.1706 48.3054V49.9305L54.2759 68.7175L55.1672 68.1489L38.1706 48.3054Z",
    fill: "#DB0032"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75845 14.1523L6.86328 14.6403L15.7304 25.0519L18.4121 26.5925L7.75845 14.1523ZM27.6826 38.9557L31.9087 43.835V42.2905L30.3681 40.5002L27.6826 38.9557ZM38.171 49.6094V51.1538L53.5425 69.1263L54.4377 68.6384L38.171 49.6094Z",
    fill: "#DC0032"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02798 14.5586L6.13281 15.0465L13.6937 23.9098L16.2985 25.3697L7.02798 14.5586ZM25.5691 37.8137L31.9082 45.1325V43.5881L28.2507 39.2775L25.5691 37.8137ZM38.1705 50.8263V52.3707L52.8082 69.5287L53.7034 69.0408L38.1705 50.8263Z",
    fill: "#DC0032"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29458 14.9688L5.39941 15.4567L11.5849 22.691L14.182 24.1548L6.29458 14.9688ZM23.5371 36.5987L31.9125 46.3572V44.8127L26.1342 38.0625L23.5371 36.5987ZM38.1748 52.1316V53.676L52.1593 69.9388L53.0545 69.4509L38.1748 52.1316Z",
    fill: "#DC0032"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56411 15.3711L4.66895 15.859L9.46749 21.4721L12.0685 22.932L5.56411 15.3711ZM21.4197 35.3759L31.9081 47.574V46.0296L24.0283 36.9242L21.4197 35.3759ZM38.1704 53.3484V54.8929L51.425 70.345L52.324 69.8571L38.1704 53.3484Z",
    fill: "#DC0032"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83071 15.7773L3.93555 16.2653L7.35485 20.2493L9.95582 21.7976L4.83071 15.7773ZM19.307 34.1571L31.9085 48.8754V47.331L21.908 35.7015L19.307 34.1571ZM38.1708 54.5691V56.1136L50.6955 70.7513L51.5906 70.2634L38.1708 54.5691Z",
    fill: "#DC0032"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10024 16.1836L3.20508 16.6715L5.24129 19.0305L7.92295 20.5749L4.10024 16.1836ZM17.1935 33.0189L31.908 50.0962V48.5479L19.7945 34.4826L17.1935 33.0189ZM38.1703 55.8667V57.415L49.965 71.1575L50.8602 70.6696L38.1703 55.8667Z",
    fill: "#DC0032"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36647 16.5117L2.39062 16.9996L3.12059 17.8948L5.80993 19.3547L3.36647 16.5117ZM15.0766 31.8025L31.9119 51.3963V49.7712L17.7583 33.2625L15.0766 31.8025ZM38.1742 57.09V58.6345L49.2312 71.647L50.1264 71.0784L38.1742 57.09Z",
    fill: "#DC0032"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63696 16.918L2.06836 17.2407L3.69349 18.1359L2.63696 16.918ZM12.964 30.5798L31.9123 52.617V51.0726L15.6457 32.1204L12.964 30.5798ZM38.1747 58.3069V59.9359L48.5824 72.0533L49.4776 71.4808L38.1747 58.3069Z",
    fill: "#DC0032"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9316 29.3594L31.9085 53.8362V52.2918L13.5326 30.9038L10.9316 29.3594ZM38.1708 59.6106V61.155L47.8524 72.458L48.7437 71.8894L38.1708 59.6106Z",
    fill: "#DC0032"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81445 28.2227L31.912 55.1391V53.514L11.4193 29.6864L8.81445 28.2227ZM38.1744 60.8328V62.3773L47.1183 72.8657L48.0135 72.2971L38.1744 60.8328Z",
    fill: "#DC0032"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70215 27L31.9128 56.3561V54.8116L9.30312 28.4638L6.70215 27ZM38.1751 62.0498V63.6749L46.3814 73.272L47.2766 72.7841L38.1751 62.0498Z",
    fill: "#DC0032"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58887 25.7812L31.9126 57.5769V56.0325L7.18984 27.3257L4.58887 25.7812ZM38.1749 63.3513V64.8958L45.6551 73.6784L46.5502 73.1905L38.1749 63.3513Z",
    fill: "#DB0032"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47168 24.5586L31.9123 58.8784V57.3301L5.0765 26.103L2.47168 24.5586ZM38.1746 64.5683V66.1127L45.0055 74.0847L45.8968 73.5968L38.1746 64.5683Z",
    fill: "#DA0032"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.359311 23.4219L31.9129 60.0968V58.5523L3.04481 24.8856L0.355469 23.4219H0.359311ZM38.1753 65.7905V67.4156L44.2724 74.4924L45.1675 74.0045L38.1753 65.7905Z",
    fill: "#D90032"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 23.3398V24.4771L31.9126 61.3172V59.7689L0.927604 23.6664L0.27832 23.3398ZM38.175 67.0877V68.0636C38.1712 68.2149 38.1125 68.3597 38.0097 68.4708L43.5421 74.8945L44.4334 74.4066L38.1711 67.0877H38.175Z",
    fill: "#D80032"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 24.1523V25.7813L31.9126 62.6176V61.0731L0.27832 24.1523ZM38.0904 68.3113C38.0136 68.6379 37.7677 68.9644 37.5218 69.0413L37.445 69.1258L42.8083 75.3036L43.7035 74.8157L38.0943 68.3113H38.0904Z",
    fill: "#D70032"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 25.4531V26.9976L31.9126 63.8377V62.2932L0.27832 25.4531ZM37.6025 68.9628C37.6025 69.0435 37.6025 69.0435 37.5257 69.0435L36.7112 69.5314L42.0783 75.713L42.9697 75.2251L37.6025 68.9628Z",
    fill: "#D60032"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 26.6758V28.2202L31.9126 65.0565V63.512L0.27832 26.6758ZM36.9532 69.3671L35.9774 69.9357L41.4252 76.198L42.3204 75.6294L36.9532 69.3671Z",
    fill: "#D50032"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 27.9766V29.521L31.9126 66.3611V64.8167L0.27832 27.9766ZM36.2233 69.7766L35.6508 70.1031C35.4895 70.18 35.3281 70.18 35.1629 70.18L40.6952 76.6075L41.5904 76.0389L36.2233 69.7766Z",
    fill: "#D40032"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 29.1953V30.7359L31.9126 67.5722V66.0277L0.27832 29.1953ZM33.703 69.7698L39.9653 77.0079L40.8566 76.4393L35.4088 70.177C35.3281 70.177 35.1629 70.2538 35.0822 70.2538H35.0054C34.7595 70.2538 34.5943 70.177 34.4291 70.0963L33.703 69.7698Z",
    fill: "#D30032"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 30.4141V32.043L39.2315 77.416L40.1266 76.8474L34.2716 70.0165L32.4812 69.0407C32.3092 68.9422 32.166 68.8002 32.0662 68.6289C31.9664 68.4576 31.9134 68.2631 31.9126 68.0648V67.2542L0.27832 30.4141Z",
    fill: "#D20032"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 31.7188V33.2632L38.4977 77.8294L39.3928 77.3376L0.27832 31.7188Z",
    fill: "#D10032"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 32.9336V34.4819L37.7677 78.2297L38.6629 77.7418L0.27832 32.9336Z",
    fill: "#D00032"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 34.1562V35.7814L37.1146 78.6379L38.0097 78.15L0.27832 34.1562Z",
    fill: "#CF0032"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 35.457V37.0015L36.3846 79.0435L37.2798 78.5556L0.27832 35.457Z",
    fill: "#CE0032"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 36.6758V38.2202L35.5701 79.3671C35.816 79.2903 36.0581 79.2058 36.3001 79.1251L36.546 78.9637L0.27832 36.6758Z",
    fill: "#CD0032"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 37.8984V39.5236L34.5136 79.3719H35.0015C35.2474 79.3719 35.4895 79.3719 35.7315 79.2874L0.27832 37.8984Z",
    fill: "#CC0032"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 39.1953V40.7398L32.6426 78.475L33.7836 79.1243C34.0257 79.2857 34.4329 79.3702 34.7595 79.3702L0.27832 39.1953Z",
    fill: "#CB0032"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 40.418V41.9624L30.5295 77.2542L33.2112 78.7987L0.27832 40.418Z",
    fill: "#CA0032"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 41.7188V43.267L28.4165 76.0386L31.0981 77.583L0.27832 41.7188Z",
    fill: "#C90032"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 42.9375V44.482L26.2996 74.8139L28.9044 76.3583L0.27832 42.9375Z",
    fill: "#C80033"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 44.1562V45.7045L24.1865 73.5968L26.7875 75.1413L0.27832 44.1562Z",
    fill: "#C70033"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 45.4609V47.0054L21.989 72.2967L24.6745 73.8411L0.27832 45.4609Z",
    fill: "#C60033"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 46.6797V48.2241L19.8759 71.0758L22.5614 72.6203L0.27832 46.6797Z",
    fill: "#C50033"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 47.8984V49.4429L17.759 69.855L20.4484 71.3994L0.27832 47.8984Z",
    fill: "#C40033"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 49.2031V50.7476L15.646 68.6394L18.3315 70.1838L0.27832 49.2031Z",
    fill: "#C30033"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 50.418V51.9624L13.5329 67.4146L16.2184 68.959L0.27832 50.418Z",
    fill: "#C20033"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 51.6367V53.2657L11.4199 66.1976L14.0208 67.742L0.27832 51.6367Z",
    fill: "#C10033"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 52.9453V54.4898L9.22229 64.9782L11.9078 66.5226L0.27832 52.9453Z",
    fill: "#C00033"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 54.1602V55.7046L7.10924 63.7573L9.7909 65.2172L0.27832 54.1602Z",
    fill: "#BF0033"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 55.3789V57.0079L4.99619 62.4557L7.67784 64.0002L0.27832 55.3789Z",
    fill: "#BE0033"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 56.6797V58.2241L2.8793 61.2324L5.56479 62.7806L0.27832 56.6797Z",
    fill: "#BD0033"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 57.8984V58.3057C0.27832 59.1202 0.846923 60.096 1.49621 60.5033L3.4479 61.5598L0.27832 57.9023V57.8984Z",
    fill: "#BC0033"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.766602 59.7695C0.927962 59.9347 1.00864 60.0961 1.17384 60.1768L0.766602 59.7695Z",
    fill: "#BB0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpd);
export default __webpack_public_path__ + "static/media/dpd.f0c9c1de401e4c69ea13be7449416014.svg";
export { ForwardRef as ReactComponent };